import React from "react";
import CmsContentPage from "../components/CmsContentPage";

/** GET …/public?limit=5&page=1&slug=help-desk */
const HELP_DESK_SLUGS = Object.freeze(["help-desk"]);

/** Support / Help Desk */
export default function Support() {
  return (
    <CmsContentPage
      slugCandidates={HELP_DESK_SLUGS}
      pageLabel="Support"
      emptyMessage="Support information has not been published yet."
    />
  );
}
